import { height } from "@mui/system";

const LoadingScreen = () => {
  return (
    <>
    <div className="w-100 d-flex justify-content-center align-items-center" style={{height:'100vh'}}>
    <span className="loader"></span>
    </div>
      <style>
        {`
          @keyframes rotation {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          .loader {
            width: 48px;
            height: 48px;
            border: 5px solid #FFF;
            border-bottom-color: transparent;
            border-radius: 50%;
            display: inline-block;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
          }
        `}
      </style>
    </>
  );
};

export default LoadingScreen;